import { ChangeDetectionStrategy, Component, Input, ViewChild } from '@angular/core';

import { MenuItem } from 'primeng/api';
import { ContextMenu } from 'primeng/contextmenu';

@Component({
  selector: 'z-grid-context-menu',
  templateUrl: './context-menu.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContextMenuComponent {
  @Input() items: MenuItem[];

  @ViewChild('contextMenu') contextMenu: ContextMenu;

  constructor() {}
}
